<template>
  <div
    :class="[
      'c-header-menu',
      `-position-${position}`,
      { 'is-visible': shouldShowMenu }
    ]"
    @mouseenter="descheduleHide"
    @mouseleave="scheduleHide"
    @touchstart.passive="startSwipe"
    @touchmove.passive="hideWithSwipe"
    @touchend.passive="endSwipe"
  >
    <div
      v-click-outside="handleClickOutside"
      class="c-header-menu__panel"
      :class="{'-transition-disabled': transitionDisabled}"
      :style="[swipeStartTouch ? { transform: `translate3d(${panelHorizontalPosition}, 0, 0)` } : {}]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
  import clickOutside from '@/tools/directives/click-outside'

  const DEFAULTS = {
    class: {
      mobileLockScroll: 't-xs-lock-scroll',
      desktopUnlockScroll: 't-md-unlock-scroll',
      isHeaderMenuOpened: 'is-header-menu-opened'
    },
    hideScheduleDelay: 200,
    swipeDistanceToHide: 100,
    horizontalCoefficient: 3 // Higher values require stricter horizontal swipe.
  }

  export default {
    name: 'VMenu',
    directives: {
      clickOutside
    },
    props: {
      shouldShowMenu: {
        type: Boolean,
        default: false
      },
      shouldScheduleMenuHide: {
        type: Boolean,
        default: false
      },
      position: {
        type: String,
        default: 'right',
        validator: function(value) {
          return ['right', 'left'].indexOf(value) !== -1
        }
      }
    },
    data() {
      return {
        hideScheduled: null,
        swipeStartTouch: null,
        transitionDisabled: false,
        panelHorizontalPosition: 0,
        isVisible: false
      }
    },
    computed: {
      triggerType() {
        return this.isLargeDesktop ? 'click' : 'hover'
      }
    },
    watch: {
      shouldScheduleMenuHide: {
        handler() {
          this.shouldScheduleMenuHide && this.scheduleHide()
        }
      },
      shouldShowMenu: {
        handler() {
          document.body.classList.toggle(DEFAULTS.class.mobileLockScroll, this.shouldShowMenu)
          document.body.classList.toggle(DEFAULTS.class.desktopUnlockScroll, this.shouldShowMenu)
          document.body.classList.toggle(DEFAULTS.class.isHeaderMenuOpened, this.shouldShowMenu)
        }
      }
    },
    methods: {
      getIsDraggableDirection(deltaX) {
        return (this.position === 'right' && deltaX > 0) || (this.position === 'left' && deltaX < 0)
      },
      handleClickOutside() {
        if (this.isVisible) {
          this.hide()
        } else {
          this.isVisible = this.shouldShowMenu
        }
      },
      startSwipe(event) {
        this.swipeStartTouch = event.changedTouches[0]
        this.transitionDisabled = true
      },
      endSwipe() {
        this.swipeStartTouch = null
        // If it was only a partial swipe that did not ended up hiding the menu
        // we need to animate the panel back to its original position.
        this.transitionDisabled = false
        this.panelHorizontalPosition = 0
      },
      hideWithSwipe(event) {
        // If current swipe was already ended we can exit
        if (!this.swipeStartTouch) return
        const lastTouch = event.changedTouches[event.changedTouches.length - 1]
        const deltaX = lastTouch.pageX - this.swipeStartTouch.pageX
        const absDeltaX = Math.abs(deltaX)
        const deltaY = lastTouch.pageY - this.swipeStartTouch.pageY
        const absDeltaY = Math.abs(deltaY)
        const isHorizontal = absDeltaX / absDeltaY > DEFAULTS.horizontalCoefficient
        if (!isHorizontal || !this.getIsDraggableDirection(deltaX)) return this.endSwipe()
        // Create the effect that the user is dragging the panel.
        this.panelHorizontalPosition = this.position === 'right' ? `${absDeltaX}px` : `-${absDeltaX}px`
        // Close the menu if user has dragged enough.
        absDeltaX - DEFAULTS.swipeDistanceToHide > 0 && this.hide()
      },
      scheduleHide() {
        if (this.triggerType === 'click') {
          return this.hide()
        }
        if (this.shouldShowMenu) {
          this.hideScheduled = setTimeout(() => {
            this.hide()
          }, DEFAULTS.hideScheduleDelay)
        }
      },
      descheduleHide() {
        clearTimeout(this.hideScheduled)
      },
      hide() {
        this.shouldShowMenu && this.$emit('close-menu')
        this.isVisible = false
      }
    }
  }
</script>
